
    import { computed, defineComponent } from 'vue'
    import { getMessage } from '@/store/messages'
    import useMessage from '@/hooks/useMessage'
    import useChat from '@/hooks/useChat'

    import ReplyHome from '@/components/Reply/ReplyHome.vue'

    export default defineComponent({
        components: { ReplyHome },

        setup () {
            const {
                clearIsMessage,
                getIsMessage,
                isMessage
            } = useMessage()
            const { setFocusTextarea } = useChat()

            const messageReply = computed(() => {
                const message = getMessage(isMessage.value)

                if (!message) return null

                return {
                    message_id: message.uuid,
                    type: message.type,
                    content: {
                        content: message.content.content,
                        message: message.content.message,
                        type: message.content.type
                    }
                }
            })

            function handleClose (): void {
                clearIsMessage()
                setFocusTextarea(true)
            }

            return {
                isMessage,
                messageReply,
                getIsMessage,
                handleClose
            }
        }
    })
